import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";

import MedicalHistoryModal from "../../../../components/pages/Settings/YachtSetUp/MedicalHistory/MedicalHistoryModal/MedicalHistoryModal";
import SaveMedicalHistory from "../../../../components/pages/Settings/YachtSetUp/MedicalHistory/SaveMedicalHistory";
import MedicalSections from "../../../../components/pages/Settings/YachtSetUp/MedicalHistory/sections/MedicalSections";
import { mapMedData } from "../../../../components/pages/Settings/YachtSetUp/MedicalHistory/utils";
import Breadcrumbs from "../../../../components/shared/Breadcrumbs/Breadcrumbs";
import { Button } from "../../../../components/shared/Button/Button";
import { useGetApi } from "../../../../hooks";
import { useDispatch, useSelector } from "../../../../redux/hooks";
import {
  resetMedState,
  setMedicalHistoryData,
} from "../../../../redux/slices/medicalHistorySlice";
import { Flex, PageContainer } from "../../../../styled";
import { getYachtId } from "../../../../utils";
import Loader from "../../../../components/shared/Loader/Loader";
import MedicalDocumentsButton from "../../../../components/pages/Settings/YachtSetUp/MedicalHistory/sections/MedicalPatientInformation/MedicalDocumentsButton";
import { useIsDev } from "src/hooks/useIsDev";

const UsersMedicalHistory = () => {
  const isDev = useIsDev();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userid } = useParams();
  const { hasMedCardStatement } = useSelector(state => state.medicalHistory);
  const { data, refetch, isLoading } = useGetApi({
    request: "get-med-history",
    body: {
      params: {
        userid,
        yachtid: getYachtId(),
      },
    },
    mapper: mapMedData,
  });

  useEffect(() => {
    dispatch(setMedicalHistoryData(data));
    isDev && data && console.log({ medicalHistoryData: data });
    return () => {
      dispatch(resetMedState());
    };
  }, [data, dispatch]);

  const methods = useForm();
  const handleNavigate = () => {
    navigate(`./medical-statements`);
  };
  return (
    <PageContainer>
      <FormProvider {...methods}>
        {isLoading ? (
          <Loader />
        ) : (
          <form>
            <Breadcrumbs border={false}>
              <Flex justify="flex-end" flex={1} gap={10}>
                <MedicalDocumentsButton refetch={refetch} />
                <Button variant="outline" onClick={handleNavigate}>
                  {hasMedCardStatement && "Update "} Medical Statement
                </Button>
                <SaveMedicalHistory refetch={refetch} />
              </Flex>
            </Breadcrumbs>
            <MedicalSections refetch={refetch} />
            <MedicalHistoryModal />
          </form>
        )}
      </FormProvider>
    </PageContainer>
  );
};
export default UsersMedicalHistory;
